import { Stack, Text, Icon, DefaultButton } from "@fluentui/react";
import { useEv2ExperimentParams } from "../Hooks/UseCurrentExtension";
import {
  styles,
  stackTokens,
  contentStackTokens,
} from "./noEv2Experiments.styles";
import BrowseOtherExtensions from "./BrowseOtherExtensions/BrowseOtherExtensions";

const NoEV2Experiments: React.FC = () => {
  const { extensionParamName } = useEv2ExperimentParams();

  return (
    <Stack
      tokens={stackTokens}
      horizontalAlign="center"
      verticalAlign="center"
      className={styles.container}
    >
      <Stack horizontalAlign="center" tokens={contentStackTokens}>
        <Icon
          iconName="Sad"
          className={styles.warningIcon}
          data-testid="sad-icon"
        />
        <Text variant="xxLarge" className={styles.title}>
          No Experiments Found
        </Text>
        <Text variant="large" className={styles.description}>
          Unable to determine the folder for <em>{extensionParamName}</em>. If
          you have not yet onboarded, you can learn about onboarding below.
        </Text>
        <div className={styles.actionSection}>
          <DefaultButton
            text="Learn More About EV2 Experiments"
            iconProps={{ iconName: "Info" }}
            href="https://eng.ms/docs/products/azure-portal-framework-ibizafx/experimentation/ev2"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.secondaryAction}
          />
        </div>
        <BrowseOtherExtensions extensionName={extensionParamName} />
      </Stack>
    </Stack>
  );
};

export default NoEV2Experiments;
